import { cards } from '@/mocks/home';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="section-container">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">精选推荐</h2>
        <p className="text-sm text-foreground-500 mb-10">根据观影偏好为你精心挑选的优质内容合集</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cards.slice(0, 3).map((card) => (
            <a
              key={card.id}
              href="#carousel"
              className="group flex flex-col rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer no-underline"
            >
              <div className="relative w-full aspect-[4/3] overflow-hidden bg-background-100">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-accent-500/90 text-background-50 text-xs font-semibold whitespace-nowrap backdrop-blur-sm">
                  {card.tag}
                </span>
              </div>
              <div className="p-4 flex flex-col gap-2 flex-1">
                <h3 className="text-base font-bold font-heading text-foreground-900 group-hover:text-primary-500 transition-colors">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">{card.desc}</p>
              </div>
            </a>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5">
          {cards.slice(3, 5).map((card) => (
            <a
              key={card.id}
              href="#carousel"
              className="group flex flex-row rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer no-underline"
            >
              <div className="relative w-[160px] sm:w-[200px] flex-shrink-0 overflow-hidden bg-background-100">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-4 flex flex-col gap-2 flex-1 justify-center">
                <span className="inline-flex px-2 py-0.5 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold whitespace-nowrap w-fit">
                  {card.tag}
                </span>
                <h3 className="text-base font-bold font-heading text-foreground-900 group-hover:text-primary-500 transition-colors">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">{card.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}